import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useState } from "react";

import { DatePicker } from "antd";
import FilterSelect from "./filterSelect.js";
import Loading from "../loader/loader.js";
import MoreInfoPopup from "./MoreInfoPopup.js";
import NkHeader from "../../common/nkheader";
import NkTable from "../users/nktable.js";
import RakProfileSectionOne from "./RakProfileSectionOne.js";
import moment from "moment";

const RakPresentational = ({
  currentStatus,
  filename,
  rowOnClick,
  description,
  profileData,
  filterValues,
  fromDate = null,
  setFromDate,
  toDate,
  setToDate,
  setModalShow,
  filtersSelected,
  noOfFiltersSelected,
  resetFilter,
  handleFIlter,
  dataLoading,
  buttonRef,
  filterForm,
  onExcelClciked,
  allUserListExcel,
  columns,
  columnsCsv,
  pagination,
  setFilterForm,
  setSizeShow,
  modalShow,
  handleChange,
  options,
  selectedOption,
  statusFilter,
  infoModalShow,
  setinfoModalShow,
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
}) => {
  console.log("profileData",profileData)
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;

  return (
    <>
      <Container fluid>
        <NkHeader title="RAK Profiles" />
        <RakProfileSectionOne
          searchBy={searchBy}
          setSearchByValue={setSearchByValue}
          setSearchBy={setSearchBy}
          searchByValuePlaceholder={searchByValuePlaceholder}
          searchByValue={searchByValue}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          setModalShow={setModalShow}
          filtersSelected={filtersSelected}
          noOfFiltersSelected={noOfFiltersSelected}
          resetFilter={resetFilter}
          handleFIlter={handleFIlter}
        />
        {filterValues && profileData.length <= 0 ? (
          <>
            <Card
              className="mb-4"
              style={{
                display: "flex",
                flex: 1,
                textAlign: "center",
                justifyContent: "center",
                padding: "1.25rem 1.5rem",
              }}
            >
              <CardBody>
                <h1 className="mb-0">Sorry ! We cannot find it</h1>
                <h3 className="mb-0">
                  Enter a different search term or remove any filters and try
                  again
                </h3>
              </CardBody>
            </Card>
          </>
        ) : (
          <>
            <Row>
              <div className="col card-parent">
                <Card style={{ padding: "1.25rem 1.5rem" }}>
                  {dataLoading ? (
                    <div style={{ textAlign: "center" }}>
                      <Loading />
                    </div>
                  ) : (
                    <>
                      <NkTable
                        dataexcal
                        filename={"rak-profile"}
                        data={profileData}
                        buttonRef={buttonRef}
                        type="rakprofile"
                        rowOnClick={rowOnClick}
                        filterdata={filterForm}
                        onExcelClciked={() => onExcelClciked(filterForm)}
                        dataEXCEL={allUserListExcel}
                        columns={columns}
                        columnsCsv={columnsCsv}
                        pagination={pagination}
                        onPagechange={(page) => {
                          setFilterForm({
                            ...filterForm,
                            page: page,
                          });
                        }}
                        showSizeChanged={(pageSize) => {
                          setSizeShow(pageSize);
                          setFilterForm({
                            ...filterForm,
                          });
                        }}
                      />
                    </>
                  )}
                </Card>
              </div>
            </Row>
          </>
        )}
      </Container>
      <FilterSelect
        show={modalShow}
        onHide={() => setModalShow(false)}
        statusFilter={statusFilter}
        selectedOption={selectedOption}
        options={options}
        handleChange={handleChange}
      />                                          
      <MoreInfoPopup
        show={infoModalShow}
        onHide={() => setinfoModalShow(false)}
        status={currentStatus}
        description={description}
        data={filename}
      />
    </>
  );
};

export default RakPresentational;
